import * as types from '../types/orderTypes';
import * as orderServices from '../../services/orderServices';

export function fetchOrders(params) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_ORDERS_REQUEST });
    try {
      const data = await orderServices.fetchOrders(params);
      const list = Array.isArray(data) ? data : (data.orders || data || []);
      dispatch({ type: types.FETCH_ORDERS_SUCCESS, payload: list });
    } catch (error) {
      dispatch({ type: types.FETCH_ORDERS_FAILURE, payload: error.message });
    }
  };
}

export function fetchOrderStats(params) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_ORDER_STATS_REQUEST });
    try {
      const data = await orderServices.fetchOrderStats(params);
      dispatch({ type: types.FETCH_ORDER_STATS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_ORDER_STATS_FAILURE, payload: error.message });
    }
  };
}

export function fetchOrderById(id) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_ORDER_BY_ID_REQUEST });
    try {
      const data = await orderServices.getOrderById(id);
      dispatch({ type: types.FETCH_ORDER_BY_ID_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_ORDER_BY_ID_FAILURE, payload: error.message });
    }
  };
}

export function updateOrderStatus(id, status) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_ORDER_STATUS_REQUEST });
    try {
      const data = await orderServices.updateOrderStatus(id, status);
      dispatch({ type: types.UPDATE_ORDER_STATUS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.UPDATE_ORDER_STATUS_FAILURE, payload: error.message });
    }
  };
}
